// this file is generated by update_shopify_store_data.py at 2026-05-05 20:28:48.110228
var courses = [];